import { apiCall } from '../utils';
import { SCORE_INFORMATION_API, SCORE_INFORMATION_TYPE } from '../constants';

import { userActions } from '.';
const { notification } = userActions;

export const scoreInformationActions = {
	getAllScoreInformation,
	getScoreInformationBySeasonId,
	updateScoreInformation,
	createScoreInformation,
	deleteScoreInformation,
}

function getAllScoreInformation() {
	return async (dispatch) => {
		dispatch(loading());

		const api = SCORE_INFORMATION_API.getAllScoreInformation();
		const { response, error } = await apiCall({ ...api });

		if (!error && response.status === 200 && response.data.success) {
			dispatch(success(response.data.data));
		} else {
			dispatch(failure(error));
			dispatch(notification({ message: 'Lấy dữ liệu thất bại!', type: 'error' }));
		}
	};

	function loading() { return { type: SCORE_INFORMATION_TYPE.GET_ALL_SCORE_INFORMATION_LOADING } }
	function success(payload) { return { type: SCORE_INFORMATION_TYPE.GET_ALL_SCORE_INFORMATION_SUCCESS, payload } }
	function failure(error) { return { type: SCORE_INFORMATION_TYPE.GET_ALL_SCORE_INFORMATION_FAILURE, error } }
}

function getScoreInformationBySeasonId(id) {
	return async (dispatch) => {
		dispatch(loading());

		const api = SCORE_INFORMATION_API.getScoreInformationBySeasonId(id);
		const { response, error } = await apiCall({ ...api });

		if (!error && response.status === 200 && response.data.success) {
			dispatch(success(response.data.data));
		} else {
			dispatch(failure(error));
			dispatch(notification({ message: 'Lấy dữ liệu thất bại!', type: 'error' }));
		}
	};

	function loading() { return { type: SCORE_INFORMATION_TYPE.GET_ALL_SCORE_INFORMATION_LOADING } }
	function success(payload) { return { type: SCORE_INFORMATION_TYPE.GET_ALL_SCORE_INFORMATION_SUCCESS, payload } }
	function failure(error) { return { type: SCORE_INFORMATION_TYPE.GET_ALL_SCORE_INFORMATION_FAILURE, error } }
}

function updateScoreInformation(payload) {
	return async (dispatch) => {
		dispatch(loading());

		const api = SCORE_INFORMATION_API.updateScoreInformation();
		const { response, error } = await apiCall({ ...api, payload });

		if (!error && response.status === 200 && response.data.success) {
			dispatch(success(response.data.data));
			return response.data.data;
		}
		dispatch(failure(error));
		dispatch(notification({ message: 'Cập nhật dữ liệu thất bại!', type: 'error' }));
		return null;
	};

	function loading() { return { type: SCORE_INFORMATION_TYPE.UPDATE_SCORE_INFORMATION_LOADING } }
	function success(payload) { return { type: SCORE_INFORMATION_TYPE.UPDATE_SCORE_INFORMATION_SUCCESS, payload } }
	function failure(error) { return { type: SCORE_INFORMATION_TYPE.UPDATE_SCORE_INFORMATION_FAILURE, error } }
}

// Tạo mới 1 bản ghi trong bảng qcv_score_infos. Dùng cho các bản ghi CẤU HÌNH
// (type = 'config', xem utils/qcv.appConfig.js) vì lần đầu cấu hình thì chưa có
// dòng nào để update.
function createScoreInformation(payload) {
	return async (dispatch) => {
		dispatch(loading());

		const api = SCORE_INFORMATION_API.createScoreInformation();
		const { response, error } = await apiCall({ ...api, payload });

		if (!error && response.status === 200 && response.data.success) {
			dispatch(success(response.data.data));
			return response.data.data;
		}
		dispatch(failure(error));
		dispatch(notification({ message: 'Tạo dữ liệu thất bại!', type: 'error' }));
		return null;
	};

	function loading() { return { type: SCORE_INFORMATION_TYPE.UPDATE_SCORE_INFORMATION_LOADING } }
	function success(payload) { return { type: SCORE_INFORMATION_TYPE.CREATE_SCORE_INFORMATION_SUCCESS, payload } }
	function failure(error) { return { type: SCORE_INFORMATION_TYPE.UPDATE_SCORE_INFORMATION_FAILURE, error } }
}

// Xoá 1 bản ghi. CẦN THIẾT cho luồng cấu hình: API update dùng GORM
// `Updates(struct)` nên bỏ qua giá trị rỗng -> không thể xoá link bằng cách lưu
// chuỗi "" được, phải xoá hẳn dòng.
function deleteScoreInformation(id) {
	return async (dispatch) => {
		dispatch(loading());

		const api = SCORE_INFORMATION_API.deleteScoreInformation(id);
		const { response, error } = await apiCall({ ...api });

		if (!error && response.status === 200 && response.data.success) {
			dispatch(success(id));
			return true;
		}
		dispatch(failure(error));
		dispatch(notification({ message: 'Xoá dữ liệu thất bại!', type: 'error' }));
		return false;
	};

	function loading() { return { type: SCORE_INFORMATION_TYPE.UPDATE_SCORE_INFORMATION_LOADING } }
	function success(payload) { return { type: SCORE_INFORMATION_TYPE.DELETE_SCORE_INFORMATION_SUCCESS, payload } }
	function failure(error) { return { type: SCORE_INFORMATION_TYPE.UPDATE_SCORE_INFORMATION_FAILURE, error } }
}
